import React from 'react';
import { motion } from 'framer-motion';

const RoleSelection = ({ formData, updateFormData, onNext }) => {
  const roles = [
    {
      id: 'photographer',
      title: 'Photographer',
      description: 'Capture and create visual content'
    },
    {
      id: 'studio_owner',
      title: 'Studio Owner',
      description: 'Manage photography business and team'
    },
    {
      id: 'photo_editor',
      title: 'Photo Editor',
      description: 'Post-process and enhance images'
    },
    {
      id: 'creative_director',
      title: 'Creative Director',
      description: 'Lead creative vision and projects'
    },
    {
      id: 'project_manager',
      title: 'Project Manager',
      description: 'Coordinate shoots and client workflows'
    },
    {
      id: 'marketing',
      title: 'Marketing',
      description: 'Promote photography services and brand'
    },
    {
      id: 'assistant',
      title: 'Photography Assistant',
      description: 'Support photographers and studio operations'
    },
    {
      id: 'other',
      title: 'Other',
      description: 'Something else in the photography industry'
    }
  ];

  const handleSelection = (role) => {
    updateFormData({ role: role.id });
    onNext();
  };

  return (
    <div className="px-8 py-12 max-w-4xl mx-auto text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-12"
      >
        <h2 className="text-4xl font-bold text-white mb-6">
          Tell us about yourself
        </h2>
        <p className="text-xl text-white/70">
          What kind of work do you do?
        </p>
        <p className="text-base text-white/50 mt-3">
          Select one
        </p>
      </motion.div>

      <div className="grid grid-cols-2 gap-4 max-w-3xl mx-auto">
        {roles.map((role, index) => (
          <motion.button
            key={role.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
            onClick={() => handleSelection(role)}
            className="p-6 rounded-xl border border-white/10 hover:border-brand hover:shadow-lg hover:shadow-orange-500/20 transition-all duration-300 text-left group bg-white/5 hover:bg-white/10"
          >
            <h3 className="font-semibold text-white group-hover:text-brand transition-colors text-lg">
              {role.title}
            </h3>
            <p className="text-sm text-white/70 mt-2">
              {role.description}
            </p>
          </motion.button>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="mt-12"
      >
        <button
          onClick={onNext}
          className="text-base text-white/50 hover:text-brand transition-colors"
        >
          Skip this step →
        </button>
      </motion.div>
    </div>
  );
};

export default RoleSelection;